document.addEventListener("DOMContentLoaded", function() {
  const customPopup = document.getElementById("customPopup");
  const loginPopup = document.getElementById("loginPopup");
  const closePopupButton = document.getElementById("closePopup");
  const elements = document.querySelectorAll("a, button");
  const overlay = document.getElementById("overlay");
  const closeLoginPopupButton = document.getElementById("closeLoginPopup");

// Function to close only the login popup
function closeLoginPopup() {
  loginPopup.style.display = "none";
  overlay.style.display = "none"; // Hide the overlay
}

// Event listener for closing the login popup
closeLoginPopupButton.addEventListener("click", function(event) {
  event.preventDefault();
  closeLoginPopup();
});
  
  function openPopup() {
    customPopup.style.display = "block";
    overlay.style.display = "block"; // Show the overlay
  }

  function openloginPopup() {
    loginPopup.style.display = "block";
    overlay.style.display = "block"; // Show the overlay
  }

  function closePopup() {
    customPopup.style.display = "none";
    overlay.style.display = "none"; // Hide the overlay
  }

  function isGetStartedElement(element) {
    return element.textContent.trim() === "Get started";
  }
  
  function isLoginElement(element) {
    return element.classList.contains("loginbtn") && element.textContent.trim() === "Login";
  }

  elements.forEach(function(element) {
    if (isGetStartedElement(element)) {
      element.addEventListener("click", function(event) {
        event.preventDefault();
        openPopup();
      });};
    if (isLoginElement(element)) {
      element.addEventListener("click", function(event) {
        event.preventDefault();
        openloginPopup();
      });
    };
  });

  closePopupButton.addEventListener("click", function(event) {
    event.preventDefault();
    closePopup();
  });

  window.addEventListener("click", function(event) {
    if (event.target === overlay) {
      closePopup();
    }
  });
});


// function to locate if page is subscription management page

// Check if the element exists in the page
// Get all elements matching the class th_sp_wf_cls thsb_cp_subscription_listing_ul
const ulElements = document.querySelectorAll('.th_sp_wf_cls.thsb_cp_subscription_listing_ul');

// Function to check if the specified text exists in the link within thsb_cp_s_product_title
function checkForText(linkElement, searchText) {
    return linkElement.textContent.includes(searchText);
}

// Check if there are matching ul elements
if (ulElements.length > 0) {
    // Loop through each ul element
    ulElements.forEach(ul => {
        // Find all elements with class thsb_cp_s_product_details_inner within each ul
        const innerProductDetails = ul.querySelectorAll('.thsb_cp_s_product_details_inner');

        // Check if there are elements with the specified inner class
        if (innerProductDetails.length > 0) {
            
            // Perform actions for each inner element found
            innerProductDetails.forEach(innerElement => {
                // Find elements with class thsb_cp_s_product_title within innerElement
                const productTitles = innerElement.querySelectorAll('.thsb_cp_s_product_title');

                // Check if product title elements exist
                if (productTitles.length > 0) {
                    
                    // Loop through each product title element found
                    productTitles.forEach(titleElement => {
                        // Find the link element within the product title
                        const linkElement = titleElement.querySelector('a');

                        // Check if the link element exists and contains specific text
                        if (
                              (linkElement && checkForText(linkElement, 'Lite')) ||
                              (linkElement && checkForText(linkElement, 'Grow')) ||
                              (linkElement && checkForText(linkElement, 'Pro'))
                                                                                  ) {

                            console.log('');
                            // Perform actions if the specific text is found
                        } else {
                            linkElement.textContent = 'Add-ons';

                              // Find elements with class thsb_cp_s_product_qty and thsb_cp_s_product_price within innerElement
                              const qtyElements = innerElement.querySelectorAll('.thsb_cp_s_product_qty');
                              const priceElements = innerElement.querySelectorAll('.thsb_cp_s_product_price');
                              const imageDivs = innerElement.querySelectorAll('.thsb_cp_s_product_image');

                              // Change the src attribute of img element if found
                              imageDivs.forEach(imageDiv => {
                                  const imgElement = imageDiv.querySelector('img');
                                  if (imgElement) {
                                      imgElement.src = 'https://cdn.shopify.com/s/files/1/0792/5494/6066/files/Grow_Full_4.png?v=1702938783'; // Replace 'new_image_url.jpg' with the desired image URL
                                  }
                              });
                          
                              // Hide the qty and price elements if found
                              qtyElements.forEach(qtyElement => {
                                  qtyElement.style.display = 'none'; // Hide the quantity element
                              });
              
                              priceElements.forEach(priceElement => {
                                  priceElement.style.display = 'none'; // Hide the price element
                              });

                        }
                    });
                } 
            });
        } 
    });
} 

